import React,{useState,useEffect,Fragment} from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';
import classes from './Confirmation.module.css';



const ConfirmUncheckAll = (props) =>{
	const handleYes = () =>{
	props.yesClick();
	}

	const handleNo = () =>{
	props.noClick();
	}
	
	return(
	<Modal className={classes.singleModal}>
		<p>Ακύρωση παραγγελίας όλων τον προϊόντων στην λίστα;</p>
		<div className={classes.buttonGrid}>
		<Button className={classes.confirmation} onClick={handleYes}>Ναι</Button>
		<Button className={classes.confirmation} onClick={handleNo}>Όχι</Button>
		</div>
	</Modal>
	)
}

export default ConfirmUncheckAll;